import { useContext } from 'react';
import Checkbox from '../../Checkbox/Checkbox';
import { ConfigurationContext, DispatchContext } from './ConfigurationContext';
import {
  isCheckboxSelected,
  isUpgradeDisabled,
  isHeaterDisabled,
  isHeaterDisabledAfterLinearChoice, isUpgradeDisabledAfterLinearChoice
} from './utils';
import FieldGroup from '../../FieldGroup/FieldGroup';

const FormStepHeaters = ({ heaterField, upgradesField }) => {
  const {
    size,
    interiorexterior: { linerType },
    heaters: { heater, upgrades },
  } = useContext(ConfigurationContext);
  const dispatch = useContext(DispatchContext);

  const isHeaterSelected = (option) => option.id === heater?.id;

  const handleHeaterChange = (option) => {
    dispatch({ type: 'SELECT_HEATER', payload: {option, upgrades: upgradesField.options} });
  };

  const handleUpgradeChange = (option, checked) => {
    dispatch({ type: 'SELECT_HEATER_UPGRADE', payload: { option, checked } });
  };

  const isSelected = (option) => {
      return isCheckboxSelected(option, upgrades)
  }

  const heaterGroupId = `${heaterField.name}-radio-group`;
  const upgradesGroupId = `${upgradesField.name}-radio-group`;

  return (
    <>
      <FieldGroup
        title={heaterField.title}
        id={heaterGroupId}
        details={heaterField.details}
      >
        {heaterField.options.map((option) => (
          <Checkbox
            key={option.id}
            type="radio"
            name={heaterGroupId}
            isChecked={isHeaterSelected(option)}
            isDisabled={isHeaterDisabled(option, size) || isHeaterDisabledAfterLinearChoice(option, linerType)}
            {...option}
            onChange={handleHeaterChange}
          />
        ))}
      </FieldGroup>

      <FieldGroup title={upgradesField.title} id={upgradesGroupId}>
        {upgradesField.options.map((option) => (
          <Checkbox
            key={option.id}
            name={upgradesGroupId}
            isChecked={isSelected(option)}
            isDisabled={!heater || isUpgradeDisabled(option, heater) || isUpgradeDisabledAfterLinearChoice(option, linerType) }
            {...option}
            onChange={handleUpgradeChange}
            upgrade={option}
            heater={heater}
          />
        ))}
      </FieldGroup>
    </>
  );
};

export default FormStepHeaters;
